import React from "react"
import { useTranslation } from "react-i18next"

import { FormOverlay } from "shared/ui/overlay/FormOverlay"

import {
  CreateMultipleTeamMembersForm,
  CreateTeamMemberFormModel
} from "features/team-member-management/ui/create-team-member-form"

export interface CreateProjectTeamMembersOverlayViewModel {
  formID: string
  formModel: CreateTeamMemberFormModel
  isSubmitting?: boolean
  onCancel: () => void
}

export const CreateProjectTeamMembersOverlayView = React.memo(
  ({
    formID,
    formModel,
    isSubmitting,
    onCancel
  }: CreateProjectTeamMembersOverlayViewModel) => {
    const { t } = useTranslation()

    return (
      <FormOverlay
        id="create-project-team-members-overlay"
        form={formID}
        headline={t("Project.Actions.InviteTeamMembers")}
        submitButtonText={t("Project.Actions.SendInvites")}
        prefix="create-project-team-members-overlay"
        onCancel={onCancel}
        isCancelHidden
        showCloseButton
        isLoading={isSubmitting}
      >
        <CreateMultipleTeamMembersForm
          {...formModel}
          id={formID}
          className="overlay-form"
        />
      </FormOverlay>
    )
  }
)
